const sidebarContent = [
  {
    name: "Dashboard",
    path: "/",
    icon: "uil:chart",
  },
  {
    name: "Salesman",
    path: "/salesman-list",
    icon: "humbleicons:users",
  },
  {
    name: "Shops",
    path: "/shops-list",
    icon: "streamline:shopping-store-2-store-shop-shops-stores",
  },
  {
    name: "Shops assign",
    path: "/shops-assign",
    icon: "clarity:assign-user-line",
  },
  {
    name: "Salesman task",
    path: "/salesman-task",
    icon: "clarity:assign-user-line",
  },
  {
    name: "Date range",
    path: "/date-range",
    icon: "fontisto:date",
  },
  {
    name: "Track salesmen",
    path: "/track-salesmen",
    icon: "logos:google-maps",
  },
];

export default sidebarContent;
